/**
 * @module store/user/actions
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';
import isUserAdmin from './helpers';

import { apiSetImage } from '@/api';


/**
 * Action: Проверка залогинен ли пользователь
 *
 * @since Version 1.0.0
 */
const checkIsLoginUser = async ({ commit }) => {
  try {
    const user = await Auth.currentUserInfo();
    console.log('user', user);

    if (!user) {
      throw new Error('Ошибка авторизации пользователя.');
    }

    // // Проверка того, что пользователь является администратором
    const isAdmin = await isUserAdmin(user);
    if (!isAdmin) {
      throw new Error('Ошибка авторизации пользователя. Пользователь не является администратором.');
    }

    commit('SET_USER', user);

    return { user };
  } catch (error) {
    return { error };
  }
};


/**
 * Action: SignOut of user
 *
 * @since Version 1.0.0
 */
const signOut = async ({ commit }) => {
  try {
    await Auth.signOut();
    commit('LOGOUT_USER');
    return {};
  } catch (error) {
    return { error };
  }
};


/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const signUp = async () => {

};


/**
 * Action: Sign in of user
 *
 * @since Version 1.0.0
 */
const signIn = async ({ commit, dispatch }, { login, password }) => {
  try {
    const user = await Auth.signIn(login, password);
    console.log('user', user);

    if (!user) {
      throw new Error('Ошибка авторизации пользователя.');
    }

    // // Проверка того, что пользователь является администратором
    const isAdmin = await isUserAdmin(user);
    if (!isAdmin) {
      throw new Error('Ошибка авторизации пользователя. Пользователь не является администратором.');
    }

    commit('SET_USER', user);
    // Загрузка настроек приложения с бекенда
    await dispatch('init', undefined, { root: true });

    return { user };
  } catch (error) {
    return { error };
  }
};

/**
 * Action: Update user image
 *
 * @since Version 1.0.0
 */
const setImage = async ({ rootGetters }, { id, image }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetImage(userSession.accessToken.jwtToken, { id, image });
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию об акциях.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};

export default {
  checkIsLoginUser,
  signIn,
  signOut,
  signUp,
  setImage,
};
